var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "headerRef",
      staticClass: "bg-white shadow-sm fixed-top",
      staticStyle: { "z-index": "1099" },
      attrs: { id: "header-logo-buttons" }
    },
    [
      _c(
        "div",
        { staticClass: "row mx-0" },
        [
          _c("skip-to-content"),
          _vm._v(" "),
          _c("div", { staticClass: "col-7 col-md-5 pl-0 pr-0" }, [
            _vm.$route.name !== "search" && _vm.$route.name !== "404"
              ? _c(
                  "div",
                  {
                    staticClass: "float-left mr-1",
                    attrs: { id: "insuranceType" }
                  },
                  [_c("span", { staticClass: "fas fa-car auto-ico-size" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "h-100 float-left pl-3", attrs: { id: "qsLogo" } },
              [
                _vm.agencyLogo
                  ? _c("img", {
                      attrs: {
                        height: "66",
                        width: "200",
                        src: require("../../assets/clients/" +
                          _vm.agencyLogo +
                          ".svg"),
                        id: "qrp-logo",
                        alt: "Rating Platform Logo"
                      }
                    })
                  : _c("img", {
                      attrs: {
                        height: "66",
                        width: "200",
                        src: require("../../assets/qrp-abbreviated-color.svg"),
                        alt: "QuinStreet Rating Platform"
                      }
                    })
              ]
            ),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.rc2ProgTrue(),
                  expression: "rc2ProgTrue()"
                }
              ],
              staticClass: "logo-sep mx-3 float-left mt-2"
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.rc2ProgTrue(),
                    expression: "rc2ProgTrue()"
                  }
                ],
                staticClass: "float-left mt-2"
              },
              [
                _c("img", {
                  attrs: {
                    height: "30",
                    width: "120",
                    src: _vm.$store.getters.getRc2LogoURL,
                    alt: "Carrier logo"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-5 col-md-7 px-0 my-auto",
              attrs: { id: "header-right-section" }
            },
            [
              _c("div", { staticClass: "row mx-0 float-right" }, [
                _vm.$route.name !== "search" &&
                _vm.quoteStatus !== "Bound" &&
                _vm.$route.name !== "404"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "cursorPointer navItem d-inline-block text-center border-right btn-fade",
                        attrs: { tabindex: "0" },
                        on: {
                          click: function($event) {
                            return _vm.popForceBindModal()
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticClass:
                            "fas fa-file-invoice-dollar d-block mx-auto uniform-icon-size",
                          attrs: { title: "Force Bind" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "btn-label" }, [
                          _vm._v("Force Bind")
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.name !== "search" && _vm.$route.name !== "404"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "cursorPointer navItem d-inline-block text-center border-right btn-fade",
                        attrs: { tabindex: "0" },
                        on: { click: _vm.updateQuoteSummaryStatus }
                      },
                      [
                        _c("span", {
                          staticClass:
                            "fas fa-scroll d-block mx-auto uniform-icon-size",
                          attrs: { title: "Quote Summary" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "btn-label" }, [
                          _vm._v("Quote Summary")
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "cursorDefault navItem d-inline-block text-center btn-fade",
                    class: {
                      disabled: _vm.$route.name === "search",
                      cursorPointer: _vm.$route.name !== "search"
                    },
                    attrs: { tabindex: "0" },
                    on: { click: _vm.searchResult }
                  },
                  [
                    _c("span", {
                      staticClass:
                        "fas fa-search d-block mx-auto uniform-icon-size",
                      attrs: { title: "Search Results" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-label" }, [
                      _vm._v("Search Results")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "border-left cursorPointer navItem d-inline-block text-center btn-fade",
                    attrs: { href: "JavaScript:void(0);", tabindex: "0" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.saveBeforNavigate($event)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass:
                        "fas fa-tachometer-alt d-block mx-auto uniform-icon-size",
                      attrs: { title: "Dashboard" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-label" }, [
                      _vm._v("Dashboard")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "border-left cursorPointer navItem d-inline-block text-center btn-fade",
                    attrs: { href: "JavaScript:void(0);", tabindex: "0" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.toUserProfile()
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass:
                        "fas fa-user-circle d-block mx-auto uniform-icon-size",
                      attrs: { title: "Dashboard" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-label" }, [
                      _vm._v(
                        _vm._s(_vm.userProfileData.firstName) +
                          " " +
                          _vm._s(_vm.userProfileData.lastName)
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "navItem d-inline-block text-center border-left cursorPointer btn-fade",
                    attrs: { href: "JavaScript:void(0);", tabindex: "0" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.onLogout($event)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass:
                        "fas fa-sign-out-alt d-block mx-auto uniform-icon-size",
                      attrs: { title: "Logout" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-label" }, [_vm._v("Logout")])
                  ]
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { name: "force-bind-modal", height: "auto", scrollable: true },
          on: { opened: _vm.forceBindModalOpen }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "breakdown-modal-top pt-3 pb-2 pl-3 pr-2 bg-primary text-white"
            },
            [
              _c("h3", { staticClass: "breakdown-modal-header" }, [
                _vm._v("Force Bind - Auto Insurance")
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "cursorBox fa-stack uniform-icon-breakdown",
                  on: {
                    click: function($event) {
                      return _vm.$modal.hide("force-bind-modal")
                    }
                  }
                },
                [
                  _c("span", {
                    staticClass: "fas fa-circle fa-stack-2x",
                    staticStyle: { color: "#fff" }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "fas fa-times fa-stack-1x",
                    staticStyle: { color: "#1C3664" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "px-3 mt-2 smaller-font-content" }, [
            _vm._v(
              "Please enter binding information if this policy has been bound in a third party system."
            )
          ]),
          _vm._v(" "),
          _vm.formErrors.general
            ? _c("div", { staticClass: "px-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "alert alert-danger",
                    attrs: { role: "alert" }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formErrors.general) +
                        "\n        "
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "px-3 mb-4",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submitForceBind($event)
                }
              }
            },
            [
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v("Binding Carrier"),
                  _c("span", { staticClass: "required-red" }, [_vm._v("*")])
                ]),
                _vm._v(" "),
                _c("select", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formFields.carrier,
                      expression: "formFields.carrier"
                    }
                  ],
                  staticClass: "form-control w-auto",
                  attrs: { id: "force-bind-carrier-select" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formFields,
                        "carrier",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _vm.formErrors.carrier
                  ? _c(
                      "div",
                      {
                        staticClass: "w-50 alert alert-danger",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formErrors.carrier) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group w-50" }, [
                _c("label", [
                  _vm._v("Policy Number"),
                  _c("span", { staticClass: "required-red" }, [_vm._v("*")])
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formFields.policyNumber,
                      expression: "formFields.policyNumber"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.formFields.policyNumber },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formFields,
                        "policyNumber",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "smaller-font-content" }, [
                  _vm._v("20 Character Maximum")
                ]),
                _vm._v(" "),
                _vm.formErrors.policyNumber
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "alert alert-danger negative-margin-error-msg",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formErrors.policyNumber) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group w-50" },
                [
                  _c("label", [
                    _vm._v("Total Premium"),
                    _c("span", { staticClass: "required-red" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "form-control",
                        attrs: { maxlength: "9" },
                        model: {
                          value: _vm.formFields.price,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields, "price", $$v)
                          },
                          expression: "formFields.price"
                        }
                      },
                      "money",
                      _vm.money,
                      false
                    )
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "smaller-font-content" }, [
                    _vm._v("7 Digit Maximum ($XXXXX.XX)")
                  ]),
                  _vm._v(" "),
                  _vm.formErrors.finalPremium
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "alert alert-danger negative-margin-error-msg",
                          attrs: { role: "alert" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formErrors.finalPremium) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", [
                  _c("label", [
                    _vm._v("Policy Term"),
                    _c("span", { staticClass: "required-red" }, [_vm._v("*")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-group btn-group-toggle",
                    attrs: { "data-toggle": "buttons" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "btn btn-outline-light",
                        class: {
                          active:
                            _vm.formFields.termLength === "12Month"
                              ? true
                              : false
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formFields.termLength,
                              expression: "formFields.termLength"
                            }
                          ],
                          attrs: {
                            name: "radio-term-length",
                            id: "term-12-mo-radio",
                            type: "radio",
                            value: "12Month"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.formFields.termLength,
                              "12Month"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.formFields,
                                "termLength",
                                "12Month"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "cursorBox",
                            attrs: { for: "term-12-mo-radio" }
                          },
                          [_vm._v("12 months")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn btn-outline-light",
                        class: {
                          active:
                            _vm.formFields.termLength === "6Month"
                              ? true
                              : false
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formFields.termLength,
                              expression: "formFields.termLength"
                            }
                          ],
                          attrs: {
                            name: "radio-term-length",
                            id: "term-6-mo-radio",
                            type: "radio",
                            value: "6Month"
                          },
                          domProps: {
                            checked: _vm._q(_vm.formFields.termLength, "6Month")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.formFields,
                                "termLength",
                                "6Month"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "cursorBox",
                            attrs: { for: "term-6-mo-radio" }
                          },
                          [_vm._v("6 months")]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.formErrors.termLength
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "alert alert-danger negative-margin-error-msg",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formErrors.termLength) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [
                    _vm._v("Policy Effective Date"),
                    _c("span", { staticClass: "required-red" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("datepicker", {
                    staticStyle: { width: "6rem" },
                    attrs: {
                      "bootstrap-styling": true,
                      typeable: true,
                      format: "MM/dd/yyyy",
                      placeholder: "MM/DD/YYYY"
                    },
                    model: {
                      value: _vm.formFields.date,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields, "date", $$v)
                      },
                      expression: "formFields.date"
                    }
                  }),
                  _vm._v(" "),
                  _vm.formErrors.effectiveDate
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: { role: "alert" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formErrors.effectiveDate) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-block justify-content-center mx-auto my-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "alert alert-warning mx-3 my-0 py-2",
                      attrs: { role: "alert" }
                    },
                    [
                      _c("div", { staticClass: "row no-gutters" }, [
                        _c(
                          "div",
                          { staticClass: "d-inline-block pr-2 my-auto" },
                          [
                            _c("img", {
                              attrs: {
                                width: "25px",
                                height: "25px",
                                src: require("../../assets/exclamation-circle-yellow.svg"),
                                alt: "info"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col smaller-font-content d-inline-block my-auto"
                          },
                          [
                            _c("p", { staticClass: "mb-0 text-dark" }, [
                              _vm._v(
                                "Advise the customer of the next steps including that they must sign the application to avoid a premium increase or cancellation."
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary btn d-block mx-auto",
                  attrs: { type: "submit", id: "force-bind-submit-button" }
                },
                [_vm._v("Force Bind Policy")]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a76565f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a76565f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/shared/Header.vue
// module id = null
// module chunks = 